<template>
  <v-dialog
    v-if="selected.length"
    v-model="dialog"
    :fullscreen="$vuetify.breakpoint.xs"
    persistent
    scrollable
    max-width="500px"
  >
    <v-card>
      <v-toolbar dark color="primary">
        <v-toolbar-title>HAPUS {{ title }}</v-toolbar-title>
      </v-toolbar>
      <v-card-title
        >{{
          `Anda yakin akan menghapus ${selected.length} ${title} berikut ini: `
        }}
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text style="height: 1000px">
        <v-chip
          v-for="(item, i) in selected"
          :key="i"
          color="primary"
          text-color="white"
        >
          <slot name="item-detail" :item="item"> </slot>
        </v-chip>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="pa-3">
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" flat @click="$emit('cancel')">TIDAK</v-btn>
        <v-btn color="primary" dark @click="submitDelete">YAKIN</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import _ from "lodash";
import { mapState } from "vuex";
export default {
  name: "pg-form-delete",
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Array,
      default: new Array()
    },
    title: {
      type: String,
      default: ""
    },
    primary_key: {
      type: String,
      default: ""
    },
    action: {
      type: String,
      default: ""
    }
  },
  computed: {
    ...mapState(["status"])
  },
  methods: {
    submitDelete() {
      let localSelected = _.cloneDeep(this.selected);
      this.$store
        .dispatch(this.action, localSelected)
        .then(ids => {
          // if detail
          if (this.$route.query.id) {
            this.$router.push({
              name: this.$route.name
            });
          }
          // them remove from selected
          _.remove(localSelected, data => {
            return ids.includes(data[this.primary_key]);
          });
          // emits to parent
          this.$emit("deleted", localSelected);
        })
        .catch();
    }
  }
};
</script>
